export default __webpack_public_path__ + "static/amycat-a049944737a0bb5096d54464105a3e08.png";